import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconForest = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconForest",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M520-120v-80h160v80q0 17-11 29t-29 11h-80q-17 0-28-11t-12-29m-240 0v-120H73q-24 0-35-21t2-41l114-178q-23 0-34-20t2-41l205-292q6-8 15-12t18-5 18 5 15 12l205 292q14 20 3 41t-35 20l115 178q13 20 2 41t-35 21H440v120q0 17-11 29t-29 11h-80q-17 0-28-11t-12-29m490-120L640-440q24 0 36-21t-3-42L505-743l62-90q6-8 15-12t18-5 18 5 15 12l205 292q14 20 3 41t-35 20l114 178q13 20 2 41t-35 21z"
  })
}));